import app from 'flarum/forum/app';
import addIgnoreUserControlButton from './addIgnoreUserControlButton';
import addIgnoreDiscussionControlButton from './addIgnoreDiscussionControlButton';
import addHideIgnoredPost from './addHideIgnoredPost';
import addProfilePage from './addProfilePage';
import addIgnoredUserBadge from './addIgnoredUserBadge';
import ProfilePage from './components/ProfilePage';
import IgnoredDiscussionsPage from './components/IgnoredDiscussionsPage';
export { default as extend } from './extend';
app.initializers.add('bizkaitarra-ignore-users', function () {
  app.routes['bizkaitarra.ignoredUsers'] = {
    path: '/usuarios-ignorados',
    component: ProfilePage
  };
  app.routes['bizkaitarra.ignoredDiscussions'] = {
    path: '/discusiones-ignoradas',
    component: IgnoredDiscussionsPage
  };
  addIgnoreUserControlButton();
  addIgnoreDiscussionControlButton();
  addHideIgnoredPost();
  addProfilePage();
  addIgnoredUserBadge();
});